
const SkinVoteRules = () => {
    return (
        <>
            <div>
                <h2> Season 9</h2>
                <h4>Price Poll  $$</h4>
                <h4> Rules</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. </p>
            </div>
        </>
    )
}

export default SkinVoteRules;
